<template>
  <div>
    <!-- BACKDROP -->
    <transition name="fade" appear>
      <div
        v-if="showPopup || showDefaultPopup"
        class="modal-backdrop custom-backdrop"
      ></div>
    </transition>

    <!-- POPUP -->
    <Transition name="fade" appear>
      <div
        class="popup-container"
        v-if="currentPopup && showPopup"
        @click="closePopup"
      >
        <div class="popup-content">
          <FontAwesomeIcon
            class="close-popup"
            :icon="['fas', 'xmark']"
            @click="closePopup"
          />
          <NuxtLink v-if="currentPopup?.image_url" class="io-popup" to="/newsletter-signup">
            <img
              :src="currentPopup.image_url + '?auto=format,compress&fm=webp'"
              :alt="currentPopup.image_url_alt_text || currentPopup.name || ''"
            />
          </NuxtLink>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from "vue";
import { useRoute } from "vue-router";
import { useMainStore } from "~/store/index";

// Utilities and composables
const { isMobile, isTablet, isDesktop } = useMobileChecker();
const { isScrolled } = useScroll();
const store = useMainStore();

const showPopup = ref(false);
const showDefaultPopup = ref(false);
const currentPopup = ref(null);

const popupViewed = useCookie("popup_viewed");

await store.getMMData("popups")
const popupList = Array.isArray(store.popups)
  ? store.popups
  : (store.popups?.popups || [])
currentPopup.value = popupList[0] || null

onMounted(() => {
  if (popupViewed.value) return

  window.setTimeout(() => {
    if (currentPopup.value) {
      showPopup.value = true
    } else {
      showDefaultPopup.value = true
    }
    popupViewed.value = "true"
  }, 10000)
});

// Handle scroll locking
const shouldLockScroll = computed(
  () => showPopup.value || showDefaultPopup.value
);

watch(shouldLockScroll, (val) => {
  document.body.classList.toggle("no-scroll", val);
  document.body.style.overflow = val ? "hidden" : "";
});

// Method to close the popup
function closePopup() {
  showPopup.value = false;
  showDefaultPopup.value = false;
}
</script>

<style lang="scss" scoped>
.close-popup {
  padding: 20px;
  height: 20px;
  width: 20px;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
  border: none;
  box-shadow: 0px 0px 0px 0px rgba(2, 2, 2, 0.23);
  // background-color: #000;
  font-weight: 700;
  font-size: 24px;
  line-height: 28px;
  color: #333333;
  text-shadow: 0px 0px 0px rgba(0, 0, 0, 0.23);
  text-align: center;
  cursor: pointer;
}

.popup-container {
  position: fixed;
  z-index: 1041;
  left: 50%;
  transform: translateX(-50%);
  background-color: $white;
  top: 230px;
  // opacity: 1;
  visibility: visible;
  max-width: 300px;
  border-radius: 8px;
  border-width: 3px;
  width: 461px;

  .popup-content {
    overflow-y: hidden;
    overflow-x: auto;
    height: 100%;
    width: 100%;
  }
}

.popup-container img {
  display: block;
  width: 100%;
  height: auto;
  max-width: 100%;
  border-radius: 8px;
}
.no-scroll {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

.io-popup {
  display: block;
  position: relative;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: $black;
  // opacity: 0.7;
}
</style>